export const lightTheme = {
  primary: "#3498db", // Bright blue - matches React and Express icons
  secondary: "#764ABC", // Purple - matches Redux icon
  background: "#ffffff",
  surface: "#f8f9fa",
  text: {
    primary: "#2c3e50",
    secondary: "#546e7a",
    light: "#78909c",
  },
  card: {
    background: "#ffffff",
    shadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  button: {
    background: "#3498db",
    text: "#ffffff",
    hover: "#2980b9",
  },
  animation: {
    transition: "0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  },
};

export const darkTheme = {
  primary: "#3498db", // Keep the same primary for consistency
  secondary: "#764ABC", // Keep the same secondary for consistency
  background: "#1a1a1a",
  surface: "#2d2d2d",
  text: {
    primary: "#ffffff",
    secondary: "#b3b3b3",
    light: "#808080",
  },
  card: {
    background: "#333333",
    shadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
  },
  button: {
    background: "#3498db",
    text: "#ffffff",
    hover: "#2980b9",
  },
  animation: {
    transition: "0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  },
};
